import { render } from "./BoardPage.vue?vue&type=template&id=45461d9d"
import script from "./BoardPage.vue?vue&type=script&lang=js"
export * from "./BoardPage.vue?vue&type=script&lang=js"

import "./BoardPage.vue?vue&type=style&index=0&id=45461d9d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__